import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { store } from './store';
import { LoginGate, useAuth } from './components/Auth';
import { Header, Sidebar, MainContent } from './components/Layout';
import { HomePage, WorkspacePage, ActivityPage, SettingsPage } from './pages';
import { useWorkspaces } from './hooks';
import { CreateWorkspaceModal } from './components/Workspace';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
  },
});

function AppLayout() {
  const { logout } = useAuth();
  const { workspaces } = useWorkspaces();
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <Header onLogout={logout} />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar
          workspaces={workspaces}
          onCreateWorkspace={() => setShowCreateModal(true)}
        />
        <MainContent>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/workspace/:name/*" element={<WorkspacePage />} />
            <Route path="/activity" element={<ActivityPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </MainContent>
      </div>

      {showCreateModal && (
        <CreateWorkspaceModal onClose={() => setShowCreateModal(false)} />
      )}
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <LoginGate>
            <AppLayout />
          </LoginGate>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
